import { POST } from "../APiHelper/API"

export const getSquadDetailsForFixture = (team_id, fixture_id, onSuccess, onError) => {
    const data = {
        team_id: team_id,
        fixture_id: fixture_id,
    }
    POST(`/api/v1/squads/fixture`, data, onSuccess, onError)
}